<template>
  <div>
    <div class="news_page_banner_out">
      <div class="container">
        <dl class="all_page_banner_txt">
          <dt>新闻资讯</dt>
          <dd>news &nbsp;&nbsp; information</dd>
        </dl>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="details_page_con">
          <div class="title">
            <h5>{{ newContent.title }}</h5>
            <p class="font-note">
              <span>时间：{{ newContent.pubDate }}</span>
              <span>撰稿人：{{ newContent.author }}</span>
            </p>
          </div>
          <div class="details" v-html="newContent.content"></div>
          <div
            class="details_page_paging"
            style="width: 80%; float: left; margin-top: 10px"
          >
            <p v-if="newContent.lastId">
              <a @click="getNextAndLast(newContent.lastId)">
                <span>上一篇：</span>{{ newContent.lastTitle }}
              </a>
            </p>
            <p v-if="newContent.nextId">
              <a @click="getNextAndLast(newContent.nextId)">
                <span>下一篇：</span>{{ newContent.nextTitle }}
              </a>
            </p>
          </div>
          <!-- <div style="width: 15%; float: left">
            <a
              style="
                display: block;
                text-align: right;
                margin-top: 50px;
                font-size: 18px;
              "
              @click="returnpage()"
            >
              <span>返回</span>
            </a>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "@/libs/api.request";
export default {
  data() {
    return {
      newContent: {     
      },
      id: 2,
    };
  },
  methods: {
    getData() {
      let data = { Id: this.id, NewsType: null };
      var posturl = this.config.baseUrl.pro + "/Base_News/apiGetNewsContent";
      axios
        .request({
          url: posturl,
          method: "post",
          changeOrigin: true, //允许跨域2
          data: data,
        })
        .then((resp) => {
          console.log(resp);
          if (resp.status === 200) {
            // newsList=
            this.newContent = resp.data.result.data;
            document.title = this.newContent.title;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$Message.info("新闻列表查询失败");
        });
    },
    getNextAndLast(id) {
      this.id = id;
      this.getData();
    },
    returnpage() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.id = this.$route.query.id;
    if (this.id == undefined) {
      this.$router.push({
        name: "newslist",
      });
    } else {
      this.getData();
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/view/details.vue